// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbarDesktop {
    display: block;
}

.navbar {
    width: 100%;
    margin: 0 auto;
    padding: 10px 15px;
   background-color: #181b25 !important; 
    margin-bottom: 1rem;
}


.navbar .address {
    border: 1px solid #424242;
    margin-left: 50px;
    padding: 5px 15px;
    background-color: #0f0f0f;
}

.navbar a:hover {
    cursor: default;
}

.nav-link, .nav-item {
    display: flex;
    align-items: center;
}

.navbar-text {
    margin-left: 50px;
}

.navbar-text:hover {
    cursor: default;
}

.noAcreditado:hover, .address:hover {
    cursor: pointer !important;
}

.toLogin {
    border: 1px solid white !important;
}

.navbarDesktop .toLogin:hover {
    cursor: pointer;
}

.navbar .connect {
    margin-left: auto;
    margin-right: 33rem; 
}

.navbar .connect img {
    width: 30px;
    margin-right: 5px;
}

.navbar .connect button {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white !important;
}

/* Media Query para dispositivos móviles (menos de 995px) */
@media (max-width: 995px) {
    .navbar ul, 
    .navbar li, 
    .navbar li a, 
    .nabvar .login, 
    .navbar .login button {
      width: 100%;
      margin: 0 auto;
    }
  
    .navbar .login button {
      margin-bottom: 5px;
    }
  
    .navbarDesktop .navbar-text {
      margin-left: 0 !important;
    }
  
    .hiddenInfoNavbar {
      display: none;
    }
  
    .navbar {
      width: 96%;
      margin: 0 2%;
      padding: 5px;
    }
  
    .navbar .collapse:not(.show) {
      display: block !important;
    }
  
    .navbar .connect {
      width: 100%; /* Ocupar todo el ancho */
      padding-left: 0;
      margin-right: 0; /* Resetear margen derecho */
      margin-left: 0;  /* Resetear margen izquierdo */
    }
  
    .navbar .connect button {
      width: 100%; /* Ocupar todo el ancho */
    }
  }
  
  /* Media Query para dispositivos móviles (menos de 995px) */
@media (max-width: 995px) {
    .navbar ul, 
    .navbar li, 
    .navbar li a, 
    .nabvar .login, 
    .navbar .login button {
      width: 100%;
      margin: 0 auto;
    }
  
    .navbar .login button {
      margin-bottom: 5px;
    }
  
    .navbarDesktop .navbar-text {
      margin-left: 0 !important;
    }
  
    .hiddenInfoNavbar {
      display: none;
    }
  
    .navbar {
      width: 96%;
      margin: 0 2%;
      padding: 5px;
    }
  
    .navbar .collapse:not(.show) {
      display: block !important;
    }
  
    .navbar .connect {
      width: 100%; /* Ocupar todo el ancho */
      padding-left: 0;
      margin: 0 !important; /* Anula cualquier margen previo */
    }
  
    .navbar .connect button {
      width: 100%; /* Botón ocupa 100% */
    }
  }
  
  @media (min-width: 768px) and (max-width: 1366px) {
    .navbar .connect button {
      width: 100% !important;
      box-sizing: border-box !important;
    }
  }

  /* Solución específica para iPad Pro - sobrescribir todos los posibles estilos */
@media (min-width: 1024px) and (max-width: 1366px) {
    /* Resetear los estilos de Bootstrap que podrían estar interfiriendo */
    .navbar-nav {
      flex-direction: column !important;
      width: 100% !important;
    }
    
    .navbar-nav.ms-auto {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      display: block !important;
    }
    
    .navbar .navbar-nav .nav-item {
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      display: block !important;
    }
    
    .navbar .navbar-nav .nav-item.connect {
      width: 100% !important;
      display: block !important;
    }
    
    .navbar .navbar-nav .nav-item button,
    .navbar-nav .nav-item.connect button,
    .navbar button.btn-warning {
      width: 100% !important;
      max-width: 100% !important;
      display: block !important;
      margin: 0 auto !important;
      box-sizing: border-box !important;
    }
    
    /* Asegurarse que el contenedor también tenga el ancho correcto */
    .container-fluid {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    
    .navbar .collapse {
      width: 100% !important;
      padding: 0 !important;
    }
  }

`, "",{"version":3,"sources":["webpack://./src/app/components/navbar-user/navbar-user.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;GACnB,oCAAoC;IACnC,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA,2DAA2D;AAC3D;IACI;;;;;MAKE,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,UAAU;MACV,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,WAAW,EAAE,yBAAyB;MACtC,eAAe;MACf,eAAe,EAAE,4BAA4B;MAC7C,cAAc,GAAG,8BAA8B;IACjD;;IAEA;MACE,WAAW,EAAE,yBAAyB;IACxC;EACF;;EAEA,2DAA2D;AAC7D;IACI;;;;;MAKE,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,UAAU;MACV,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,WAAW,EAAE,yBAAyB;MACtC,eAAe;MACf,oBAAoB,EAAE,kCAAkC;IAC1D;;IAEA;MACE,WAAW,EAAE,qBAAqB;IACpC;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,iCAAiC;IACnC;EACF;;EAEA,gFAAgF;AAClF;IACI,sEAAsE;IACtE;MACE,iCAAiC;MACjC,sBAAsB;IACxB;;IAEA;MACE,oBAAoB;MACpB,qBAAqB;MACrB,sBAAsB;MACtB,yBAAyB;IAC3B;;IAEA;MACE,sBAAsB;MACtB,oBAAoB;MACpB,qBAAqB;MACrB,yBAAyB;IAC3B;;IAEA;MACE,sBAAsB;MACtB,yBAAyB;IAC3B;;IAEA;;;MAGE,sBAAsB;MACtB,0BAA0B;MAC1B,yBAAyB;MACzB,yBAAyB;MACzB,iCAAiC;IACnC;;IAEA,iEAAiE;IACjE;MACE,0BAA0B;MAC1B,2BAA2B;IAC7B;;IAEA;MACE,sBAAsB;MACtB,qBAAqB;IACvB;EACF","sourcesContent":[".navbarDesktop {\n    display: block;\n}\n\n.navbar {\n    width: 100%;\n    margin: 0 auto;\n    padding: 10px 15px;\n   background-color: #181b25 !important; \n    margin-bottom: 1rem;\n}\n\n\n.navbar .address {\n    border: 1px solid #424242;\n    margin-left: 50px;\n    padding: 5px 15px;\n    background-color: #0f0f0f;\n}\n\n.navbar a:hover {\n    cursor: default;\n}\n\n.nav-link, .nav-item {\n    display: flex;\n    align-items: center;\n}\n\n.navbar-text {\n    margin-left: 50px;\n}\n\n.navbar-text:hover {\n    cursor: default;\n}\n\n.noAcreditado:hover, .address:hover {\n    cursor: pointer !important;\n}\n\n.toLogin {\n    border: 1px solid white !important;\n}\n\n.navbarDesktop .toLogin:hover {\n    cursor: pointer;\n}\n\n.navbar .connect {\n    margin-left: auto;\n    margin-right: 33rem; \n}\n\n.navbar .connect img {\n    width: 30px;\n    margin-right: 5px;\n}\n\n.navbar .connect button {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid white !important;\n}\n\n/* Media Query para dispositivos móviles (menos de 995px) */\n@media (max-width: 995px) {\n    .navbar ul, \n    .navbar li, \n    .navbar li a, \n    .nabvar .login, \n    .navbar .login button {\n      width: 100%;\n      margin: 0 auto;\n    }\n  \n    .navbar .login button {\n      margin-bottom: 5px;\n    }\n  \n    .navbarDesktop .navbar-text {\n      margin-left: 0 !important;\n    }\n  \n    .hiddenInfoNavbar {\n      display: none;\n    }\n  \n    .navbar {\n      width: 96%;\n      margin: 0 2%;\n      padding: 5px;\n    }\n  \n    .navbar .collapse:not(.show) {\n      display: block !important;\n    }\n  \n    .navbar .connect {\n      width: 100%; /* Ocupar todo el ancho */\n      padding-left: 0;\n      margin-right: 0; /* Resetear margen derecho */\n      margin-left: 0;  /* Resetear margen izquierdo */\n    }\n  \n    .navbar .connect button {\n      width: 100%; /* Ocupar todo el ancho */\n    }\n  }\n  \n  /* Media Query para dispositivos móviles (menos de 995px) */\n@media (max-width: 995px) {\n    .navbar ul, \n    .navbar li, \n    .navbar li a, \n    .nabvar .login, \n    .navbar .login button {\n      width: 100%;\n      margin: 0 auto;\n    }\n  \n    .navbar .login button {\n      margin-bottom: 5px;\n    }\n  \n    .navbarDesktop .navbar-text {\n      margin-left: 0 !important;\n    }\n  \n    .hiddenInfoNavbar {\n      display: none;\n    }\n  \n    .navbar {\n      width: 96%;\n      margin: 0 2%;\n      padding: 5px;\n    }\n  \n    .navbar .collapse:not(.show) {\n      display: block !important;\n    }\n  \n    .navbar .connect {\n      width: 100%; /* Ocupar todo el ancho */\n      padding-left: 0;\n      margin: 0 !important; /* Anula cualquier margen previo */\n    }\n  \n    .navbar .connect button {\n      width: 100%; /* Botón ocupa 100% */\n    }\n  }\n  \n  @media (min-width: 768px) and (max-width: 1366px) {\n    .navbar .connect button {\n      width: 100% !important;\n      box-sizing: border-box !important;\n    }\n  }\n\n  /* Solución específica para iPad Pro - sobrescribir todos los posibles estilos */\n@media (min-width: 1024px) and (max-width: 1366px) {\n    /* Resetear los estilos de Bootstrap que podrían estar interfiriendo */\n    .navbar-nav {\n      flex-direction: column !important;\n      width: 100% !important;\n    }\n    \n    .navbar-nav.ms-auto {\n      margin: 0 !important;\n      padding: 0 !important;\n      width: 100% !important;\n      display: block !important;\n    }\n    \n    .navbar .navbar-nav .nav-item {\n      width: 100% !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      display: block !important;\n    }\n    \n    .navbar .navbar-nav .nav-item.connect {\n      width: 100% !important;\n      display: block !important;\n    }\n    \n    .navbar .navbar-nav .nav-item button,\n    .navbar-nav .nav-item.connect button,\n    .navbar button.btn-warning {\n      width: 100% !important;\n      max-width: 100% !important;\n      display: block !important;\n      margin: 0 auto !important;\n      box-sizing: border-box !important;\n    }\n    \n    /* Asegurarse que el contenedor también tenga el ancho correcto */\n    .container-fluid {\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    }\n    \n    .navbar .collapse {\n      width: 100% !important;\n      padding: 0 !important;\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
